import styled from "styled-components";
const EmployeeSc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px auto;
  border-radius: 8px;
  gap: 0.8rem;
  width: 98vw;
  position: absolute;
  top: 50px;
  padding: 10px;
  flex-direction: column;
  .employee_header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #edecec;
    padding: 10px;
    border-radius: 8px;
  }
`;
export default EmployeeSc;
